import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=b2ece1f2&scoped=true&"
import script from "./TableAction.vue?vue&type=script&lang=js&"
export * from "./TableAction.vue?vue&type=script&lang=js&"
import style0 from "./TableAction.vue?vue&type=style&index=0&id=b2ece1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ece1f2",
  null
  
)

export default component.exports